import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePlatformStatus } from "../context/PlatformStatusContext";

/**
 * Wrapper component that checks platform status on every route change
 */
const PlatformCheckWrapper = ({ children }) => {
  const location = useLocation();
  const { checkPlatformStatus } = usePlatformStatus();

  // Check platform status on every route change
  useEffect(() => {
    checkPlatformStatus();
  }, [location.pathname, checkPlatformStatus]);

  return children;
};

export default PlatformCheckWrapper;
